import axios from "axios";
import { apiVariable } from "./apiVariable";
import {
  ExternalEventCreateUpdateDto,
  ExternalEventDto,
  ExternalEventGoingEmployeeDto,
  ExternalEventInterestedEmployeeDto,
} from "../interfaces/HR/externalEvent";

const endpoint = `${apiVariable}/hr/external-events`;

export const getExternalEvents = async (token: string) => {
  const { data } = await axios.get<ExternalEventDto[]>(endpoint, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const createExternalEvent = async (
  token: string,
  payload: ExternalEventCreateUpdateDto,
) => {
  const { data } = await axios.post<ExternalEventDto>(endpoint, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const updateExternalEvent = async (
  token: string,
  payload: ExternalEventCreateUpdateDto,
) => {
  const { data } = await axios.put<ExternalEventDto>(endpoint, payload, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
};

export const deleteExternalEvent = async (token: string, id: string) => {
  await axios.delete(`${endpoint}/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const markInterestedInExternalEvent = async (
  token: string,
  id: string,
  employeeId: string,
) => {
  await axios.post(
    `${endpoint}/${id}/interested?employeeId=${employeeId}`,
    undefined,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const unmarkInterestedInExternalEvent = async (
  token: string,
  id: string,
  employeeId: string,
) => {
  await axios.delete(`${endpoint}/${id}/interested?employeeId=${employeeId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const markGoingToExternalEvent = async (
  token: string,
  id: string,
  employeeId: string,
) => {
  await axios.post(
    `${endpoint}/${id}/going?employeeId=${employeeId}`,
    undefined,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const unmarkGoingToExternalEvent = async (
  token: string,
  id: string,
  employeeId: string,
) => {
  await axios.delete(`${endpoint}/${id}/going?employeeId=${employeeId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const getExternalEventInterestedEmployees = async (
  token: string,
  id: string,
) => {
  const { data } = await axios.get<ExternalEventInterestedEmployeeDto[]>(
    `${endpoint}/${id}/interested`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data;
};

export const getExternalEventGoingEmployees = async (
  token: string,
  id: string,
) => {
  const { data } = await axios.get<ExternalEventGoingEmployeeDto[]>(
    `${endpoint}/${id}/going`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return data;
};
